<template>
  <div class="config-default-model-container">
    <display-title :error="displayTitleError" :error-message="displayTitleErrorMessage" :disabled="finishedHighlight" />
    <div>
      <span class="header-image-title">Selecione a imagem do destaque </span>
      <mf-image-cropper
        class="mt-4"
        :mb-size-limit="0.5"
        :disabled="finishedHighlight"
        :upload-image="modifyImg"
        :error-message="errorMessage"
        :url="imageURL"
        :width="100"
        :height="100"
        show-hint
        @remove-image="deleteFile"
        @snackbar="showSnackbar"
      />
    </div>
    <selected-products />
  </div>
</template>
<script>
import { MUTATION_SINGLE_UPLOAD_BASE64 } from '@/graphql'
import { highlightOffer } from '../../../../mixins/highlight-offer'

export default {
  name: 'ConfigDefaultModel',
  components: {
    DisplayTitle: () => import('./DisplayTitle.vue'),
    SelectedProducts: () => import('./SelectedProducts.vue'),
  },
  mixins: [highlightOffer],
  props: {
    iconImageError: {
      type: Boolean,
      default: false,
    },
    displayTitleError: {
      type: Boolean,
      default: false,
    },
    displayTitleErrorMessage: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    displayTitle: '',
    imageUploaded: false,
  }),
  computed: {
    imageURL: {
      get() {
        return this.highlightIconImage
      },
      set(value) {
        this.setHighlightKeyValue({ payload: value, key: 'iconImage' })
      },
    },
    finishedHighlight() {
      return this.highlightStatus === 'FINISHED'
    },
    errorMessage() {
      return this.iconImageError ? 'Selecione uma imagem para o destaque.' : ''
    },
  },
  methods: {
    showSnackbar(snackbar) {
      this.$snackbar(snackbar)
    },
    deleteFile() {
      if (!this.finishedHighlight) {
        this.imageURL = ''
      }
    },
    async modifyImg({ base64, filename }) {
      await this.$apollo
        .mutate({
          mutation: MUTATION_SINGLE_UPLOAD_BASE64,
          variables: {
            filename,
            base64,
          },
        })
        .then(({ data: { singleUploadBase64 } }) => {
          const { url } = singleUploadBase64
          this.imageUploaded = true
          this.imageURL = url
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.config-default-model-container {
  display: flex;
  flex-direction: column;
  gap: 40px;
  .error-message {
    color: $vermelho-0;
  }
  .header-image-title {
    color: $cinza-d10;
    font-family: Lato;
    font-size: 18px;
    font-weight: 700;
  }
}
</style>
